import module from './index'

let moduleName = 'module->' + module.info.name;
const routes = [
    {
        path: module.info.name,
        name: moduleName,
        component: () => import('./View.vue'),
        children: [
            {
                path: ':division',
                name: moduleName + '->division',
                component: () => import('./division-view/View.vue'),
                children: [
                    {
                        path: 'panel-tabs',
                        name: moduleName + '->division->panel-tabs',
                        component: () => import('./panel-tabs/View'),
                        children: [
                            {
                                path: ':tabName',
                                name: moduleName + '->division->panel-tabs->tab',
                                component: () => import('./panel-tabs/tabs/View.vue'),
                                children: [
                                    {
                                        path: 'list',
                                        name: moduleName + '->division->panel-tabs->tab->list',
                                        component: () => import('./broadcast-history/View'),
                                        children: [
                                            {
                                                path: ':listPage',
                                                name: moduleName + '->division->panel-tabs->tab->list->page',
                                                component: () => import('./broadcast-history/page/View'),
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                ]
            },
            /*{
              path: 'create',
              name: moduleName + '->create',
              component: () => import('./create/View'),
            },*/
        ]
    }
];

export default routes
